import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import Condenser from 'features/processFlowDiagrams/svg/heat-exchangers/condenser.svg?react'
import DoublePipeHeatExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/double-pipe-heat-exchanger.svg?react'
import ElectricHeater from 'features/processFlowDiagrams/svg/heat-exchangers/electric-heater.svg?react'
import FixedStraightTubesHeatExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/fixed-straight-tubes-heat-exchanger.svg?react'
import HairpinExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/hairpin-exchanger.svg?react'
import HeatExchangerCoilTubes from 'features/processFlowDiagrams/svg/heat-exchangers/heat-exchanger-coil-tubes.svg?react'
import HeatExchangerFinnedTubes from 'features/processFlowDiagrams/svg/heat-exchangers/heat-exchanger-finned-tubes.svg?react'
import HeatExchangerFinnedTubesFan from 'features/processFlowDiagrams/svg/heat-exchangers/heat-exchanger-finned-tubes-fan.svg?react'
import HeatExchangerFloatingHead from 'features/processFlowDiagrams/svg/heat-exchangers/heat-exchanger-floating-head.svg?react'
import HeatExchangerPlate from 'features/processFlowDiagrams/svg/heat-exchangers/heat-exchanger-plate.svg?react'
import HeatExchangerSpiral from 'features/processFlowDiagrams/svg/heat-exchangers/heat-exchanger-spiral.svg?react'
import HeatExchangerStraightTubes from 'features/processFlowDiagrams/svg/heat-exchangers/heat-exchanger-straight-tubes.svg?react'
import Heater from 'features/processFlowDiagrams/svg/heat-exchangers/heater.svg?react'
import PlateAndFrameHeatExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/plate-and-frame-heat-exchanger.svg?react'
import Reboiler from 'features/processFlowDiagrams/svg/heat-exchangers/reboiler.svg?react'
import ShellAndTubeHeatExchanger1 from 'features/processFlowDiagrams/svg/heat-exchangers/shell-and-tube-heat-exchanger-1.svg?react'
import ShellAndTubeHeatExchanger2 from 'features/processFlowDiagrams/svg/heat-exchangers/shell-and-tube-heat-exchanger-2.svg?react'
import ShellAndTubeHeatExchanger3 from 'features/processFlowDiagrams/svg/heat-exchangers/shell-and-tube-heat-exchanger-3.svg?react'
import SinglePassHeatExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/single-pass-heat-exchanger.svg?react'
import SpiralHeatExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/spiral-heat-exchanger.svg?react'
import ThinFilmEvaporator from 'features/processFlowDiagrams/svg/heat-exchangers/thin-film-evaporator.svg?react'
import UShapedTubesHeatExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/u-shaped-tubes-heat-exchanger.svg?react'
import UTubeHeatExchanger from 'features/processFlowDiagrams/svg/heat-exchangers/u-tube-heat-exchanger.svg?react'
import React from 'react'

export const PID_HEAT_EXCHANGERS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'condenser',
    name: 'Condenser',
    category: 'heat-exchangers',
    svgContent: <Condenser />,
    viewBox: '0 0 80 80',
  },
  {
    id: 'double-pipe-heat-exchanger',
    name: 'Double Pipe Heat Exchanger',
    category: 'heat-exchangers',
    svgContent: <DoublePipeHeatExchanger />,
    viewBox: '0 0 90 50',
  },
  {
    id: 'electric-heater',
    name: 'Electric Heater',
    category: 'heat-exchangers',
    svgContent: <ElectricHeater />,
    viewBox: '0 0 140 100',
  },
  {
    id: 'fixed-straight-tubes-heat-exchanger',
    name: 'Fixed Straight Tubes Heat Exchanger',
    category: 'heat-exchangers',
    svgContent: <FixedStraightTubesHeatExchanger />,
    viewBox: '0 0 100 40',
  },
  {
    id: 'hairpin-exchanger',
    name: 'Hairpin Exchanger',
    category: 'heat-exchangers',
    svgContent: <HairpinExchanger />,
    viewBox: '0 0 91 30',
  },
  {
    id: 'heater',
    name: 'Heater',
    category: 'heat-exchangers',
    svgContent: <Heater />,
    viewBox: '0 0 80 80',
  },
  {
    id: 'heat-exchanger-coil-tubes',
    name: 'Heat Exchanger (Coil Tubes)',
    category: 'heat-exchangers',
    svgContent: <HeatExchangerCoilTubes />,
    viewBox: '0 0 100 30',
  },
  {
    id: 'heat-exchanger-finned-tubes',
    name: 'Heat Exchanger (Finned Tubes)',
    category: 'heat-exchangers',
    svgContent: <HeatExchangerFinnedTubes />,
    viewBox: '0 0 100 30',
  },
  {
    id: 'heat-exchanger-finned-tubes-fan',
    name: 'Heat Exchanger (Finned Tubes, Fan)',
    category: 'heat-exchangers',
    svgContent: <HeatExchangerFinnedTubesFan />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'heat-exchanger-floating-head',
    name: 'Heat Exchanger (Floating Head)',
    category: 'heat-exchangers',
    svgContent: <HeatExchangerFloatingHead />,
    viewBox: '0 0 100 30',
  },
  {
    id: 'heat-exchanger-plate',
    name: 'Heat Exchanger (Plate)',
    category: 'heat-exchangers',
    svgContent: <HeatExchangerPlate />,
    viewBox: '0 0 100 30',
  },
  {
    id: 'heat-exchanger-spiral',
    name: 'Heat Exchanger (Spiral)',
    category: 'heat-exchangers',
    svgContent: <HeatExchangerSpiral />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'heat-exchanger-straight-tubes',
    name: 'Heat Exchanger (Straight Tubes)',
    category: 'heat-exchangers',
    svgContent: <HeatExchangerStraightTubes />,
    viewBox: '0 0 100 30',
  },
  {
    id: 'plate-and-frame-heat-exchanger',
    name: 'Plate and Frame Heat Exchanger',
    category: 'heat-exchangers',
    svgContent: <PlateAndFrameHeatExchanger />,
    viewBox: '0 0 100 120',
  },
  {
    id: 'reboiler',
    name: 'Reboiler',
    category: 'heat-exchangers',
    svgContent: <Reboiler />,
    viewBox: '0 0 91 33',
  },
  {
    id: 'shell-and-tube-heat-exchanger-1',
    name: 'Shell and Tube Heat Exchanger 1',
    category: 'heat-exchangers',
    svgContent: <ShellAndTubeHeatExchanger1 />,
    viewBox: '0 0 60 60',
  },
  {
    id: 'shell-and-tube-heat-exchanger-2',
    name: 'Shell and Tube Heat Exchanger 2',
    category: 'heat-exchangers',
    svgContent: <ShellAndTubeHeatExchanger2 />,
    viewBox: '0 0 60 60',
  },
  {
    id: 'shell-and-tube-heat-exchanger-3',
    name: 'Shell and Tube Heat Exchanger 3',
    category: 'heat-exchangers',
    svgContent: <ShellAndTubeHeatExchanger3 />,
    viewBox: '0 0 60 60',
  },
  {
    id: 'single-pass-heat-exchanger',
    name: 'Single Pass Heat Exchanger',
    category: 'heat-exchangers',
    svgContent: <SinglePassHeatExchanger />,
    viewBox: '0 0 90 30',
  },
  {
    id: 'spiral-heat-exchanger',
    name: 'Spiral Heat Exchanger',
    category: 'heat-exchangers',
    svgContent: <SpiralHeatExchanger />,
    viewBox: '0 0 100 95',
  },
  {
    id: 'thin-film-evaporator',
    name: 'Thin-Film Evaporator',
    category: 'heat-exchangers',
    svgContent: <ThinFilmEvaporator />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'u-tube-heat-exchanger',
    name: 'U-Tube Heat Exchanger',
    category: 'heat-exchangers',
    svgContent: <UTubeHeatExchanger />,
    viewBox: '0 0 91 30',
  },
  {
    id: 'u-shaped-tubes-heat-exchanger',
    name: 'U Shaped Tubes Heat Exchanger',
    category: 'heat-exchangers',
    svgContent: <UShapedTubesHeatExchanger />,
    viewBox: '0 0 100 30',
  },
]
